import { render, staticRenderFns } from "./FormularioNomina.vue?vue&type=template&id=4a36ccc3&scoped=true"
import script from "./FormularioNomina.vue?vue&type=script&lang=js"
export * from "./FormularioNomina.vue?vue&type=script&lang=js"
import style0 from "./FormularioNomina.vue?vue&type=style&index=0&id=4a36ccc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a36ccc3",
  null
  
)

export default component.exports